/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Media_Save_FailedInputs */

const vi_media_save_failed = /** @type {(inputs: Media_Save_FailedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Không lưu được thông tin ảnh. Thử lại sau ít phút.`)
};

/**

* @param {Media_Save_FailedInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const media_save_failed = /** @type {((inputs?: Media_Save_FailedInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Media_Save_FailedInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_media_save_failed(inputs)
});